module.exports = __webpack_public_path__ + "static/media/mode-6.9f085998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-6.svg
// module id = 979
// module chunks = 2